'use client';

import { EntityProcedureScheduleCard } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedure-schedule-card.component';
import { EntityProcedureProfessionalCard } from '@/app/(main)/(pages)/_components/entities/entity-procedure/_components/entity-procedure-professional-card.component';
import { EntityProceduresSection } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedures-section.component';
import { UsePartnerProceduresReturn } from '@/app/(main)/(pages)/(institucional)/(index)/parceiros/_hooks/use-partner-procedures.hook';
import { EntityProceduresAnalytics } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedures-section.component';
import { SearchApiServiceChannel } from '@/app/(main)/(pages)/_types/search-api-response.type';
import { ScheduleTabOrigin } from '@/types/enums/analytics/search/search-analytics.enum';
import { CHANNEL_MODALITY, ScheduleTabAnalytics } from '@/app/(main)/(pages)/busca/[slug]/_utils/schedule-tab-analytics.util';
import { EntityAnalyticsProperties } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedure-analytics.type';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

const PARTNER_CHANNEL_TABS = {
  [SearchApiServiceChannel.IN_PERSON]: AnalyticsEnum.CLICK_PARTNER_IN_PERSON_TAB,
  [SearchApiServiceChannel.TELEHEALTH]: AnalyticsEnum.CLICK_PARTNER_TELEHEALTH_TAB,
};

interface PartnerSchedulesSectionProps {
  procedures: UsePartnerProceduresReturn;
  partnerId: string;
  className?: string;
  scrollTargetId?: string;
}

export function PartnerSchedulesSection({
  procedures,
  partnerId,
  className,
  scrollTargetId,
}: PartnerSchedulesSectionProps) {
  const entityProperties: EntityAnalyticsProperties = {
    entity: partnerId,
    entityType: EntityTypeEnum.CLINIC,
  };
  const analytics: EntityProceduresAnalytics = {
    channelTabs: PARTNER_CHANNEL_TABS,
    properties: entityProperties,
  };
  const tabAnalytics: ScheduleTabAnalytics = {
    origin: ScheduleTabOrigin.PARTNER_PROFILE,
    modalidade: CHANNEL_MODALITY[procedures.activeChannel],
    ...entityProperties,
  };

  return (
    <EntityProceduresSection
      procedures={procedures}
      title="Atendimentos"
      className={className}
      scrollTargetId={scrollTargetId}
      analytics={analytics}
      renderProcedure={(procedure, index) => (
        <EntityProcedureScheduleCard
          key={procedure.id}
          accordionKey={procedure.id}
          title={procedure.name}
          defaultOpen={index === 0}
          analyticsExpandEvent={AnalyticsEnum.CLICK_PARTNER_EXPAND_PROCEDURE}
          analyticsExpandProperties={{ ...entityProperties, procedure_id: procedure.id }}
        >
          {procedure.professionals.map((professional, professionalIndex) => (
            <EntityProcedureProfessionalCard
              key={professional.id}
              professional={professional}
              tabAnalytics={tabAnalytics}
              position={professionalIndex}
            />
          ))}
        </EntityProcedureScheduleCard>
      )}
    />
  );
}
